import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import Collapse from '@mui/material/Collapse'
import DownloadIcon from '@mui/icons-material/Download'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import {
  DataTable,
  TableHeader,
  TableHeaderActions,
  Table,
  TableHead,
  TableRow,
  TableHeaderCell,
} from '../styles'

const EmptyState = ({ message }) => (
  <Box sx={{ padding: '48px', textAlign: 'center', color: '#6b7280' }}>
    {message}
  </Box>
)

const PerformanceTable = ({
  title,
  subtitle,
  chipLabel,
  onExport,
  headers,
  data,
  renderRow,
  emptyMessage = 'No data available',
  defaultExpanded = true,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded)
  return (
    <DataTable elevation={0}>
      <TableHeader
        sx={{
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: theme => theme.palette.primary?.dark || '#0056b3',
          },
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton
            size="small"
            sx={{
              color: 'white',
              p: 0.5,
            }}
            onClick={e => {
              e.stopPropagation()
              setExpanded(!expanded)
            }}
          >
            {expanded ? (
              <ExpandLessIcon style={{ color: 'white' }} />
            ) : (
              <ExpandMoreIcon style={{ color: 'white' }} />
            )}
          </IconButton>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography
                variant="body2"
                sx={theme => ({
                  color: theme.palette.common?.white || 'white',
                  opacity: 0.8,
                  mt: 0.5,
                })}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>
        <TableHeaderActions onClick={e => e.stopPropagation()}>
          <Typography
            variant="body2"
            sx={theme => ({
              color: theme.palette.common?.white || 'white',
              opacity: 0.9,
              fontWeight: 500,
              mr: 2,
            })}
          >
            {chipLabel}
          </Typography>
          <Tooltip title="Export to CSV">
            <IconButton
              size="small"
              onClick={onExport}
              sx={{
                color: 'white',
                '&:hover': {
                  backgroundColor: '#ffffff1a',
                },
              }}
            >
              <DownloadIcon fontSize="small" style={{ color: 'white' }} />
            </IconButton>
          </Tooltip>
        </TableHeaderActions>
      </TableHeader>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {data && data.length > 0 ? (
          <Box sx={{ overflowX: 'auto' }}>
            <Table>
              <TableHead>
                <tr>
                  {headers.map((header, index) => (
                    <TableHeaderCell key={index}>
                      {header.tooltip ? (
                        <Tooltip title={header.tooltip}>
                          <span>{header.label}</span>
                        </Tooltip>
                      ) : (
                        header.label
                      )}
                    </TableHeaderCell>
                  ))}
                </tr>
              </TableHead>
              <tbody>
                {data.map((row, index) => (
                  <TableRow key={index}>{renderRow(row, index)}</TableRow>
                ))}
              </tbody>
            </Table>
          </Box>
        ) : (
          <EmptyState message={emptyMessage} />
        )}
      </Collapse>
    </DataTable>
  )
}

export default PerformanceTable
